import { deburr } from 'lodash-es'

export const cleanSearchValue = (search: string) => {
  return deburr(search).toLowerCase().trim()
}
